import React, { useState, useEffect } from "react";
import HelpModal from "common/HelpModal";
import Loading from "common/Loading";
import renderMarkdown from "./markdown";

export const passTextIfOk = (response) => {
  if (!response.ok) {
    throw new Error(`Help content load failed (HTTP ${response.status})`);
  }
  return response.text();
};

export const loadText = (source) =>
  fetch(source)
    .then(passTextIfOk)
    .then((text) => ({ text }));

const mayFail = (error) =>
  console.error(error) || { text: "Error loading help content." };

// Fetch inside an effect keyed on `source` so the promise is never
// re-instantiated on unrelated re-renders (which would otherwise refetch
// on every render). See Request.tsx's [during] effect.
export const LoadMarkdown = ({ source }) => {
  const [text, setText] = useState(null);

  useEffect(() => {
    let mounted = true;
    setText(null);
    loadText(source)
      .catch(mayFail)
      .then(({ text }) => {
        if (mounted) {
          setText(text);
        }
      });
    return () => {
      mounted = false;
    };
  }, [source]);

  if (text === null) {
    return <Loading />;
  }
  return <>{renderMarkdown(text)}</>;
};

const MarkdownHelpModal = ({ source, ...props }) => (
  <HelpModal
    {...props}
    content={() => <LoadMarkdown source={source} />}
  />
);

export default MarkdownHelpModal;
